<script>
import { OrganizationsService } from 'frontend/organizations/organizations-service'
import { useTheme } from 'frontend/themes/composables/useTheme'
import ToggleComponent from 'frontend/ui/components/ToggleComponent.vue'

import car from './car_75.jpeg'

export default {
  name: 'SessionLayout',
  data() {
    return {
      car,
      imageFetched: false,
      customBgImage: null,
    }
  },
  setup() {
    const organizationsService = new OrganizationsService()
    const { isDarkModeEnabled } = useTheme()

    return {
      organizationsService,
      isDarkModeEnabled,
    }
  },
  computed: {
    isOnMainDomain() {
      return window.location.host == this.$mainDomain
    },
  },
  async created() {
    if (this.isOnMainDomain) {
      this.imageFetched = true
    } else {
      this.customBgImage = await this.organizationsService.fetchCustomBackgroundImageByDomain()
      this.imageFetched = true
    }
  },
  components: { ToggleComponent },
}
</script>
<template lang="pug">
.welcome-container
  .thumbnail-wrapper
    .left
      .penalty-area
        .goal-area
        .penalty-spot
      .penalty-arc-wrapper
        .penalty-arc
    .right
      .half-circle
        .circle-dot
  .page-wrapper
    toggle-component.theme-toggle(
      v-model:isChecked="isDarkModeEnabled"
      checked-icon="mi mi-dark-mode"
      unchecked-icon="mi mi-light-mode"
    )
    router-view
    .copyright FIFA Transport, © {{ currentYear }} FIFA All rights reserved
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;
@import '../../frontend_stylesheets/_variables.scss';
@import 'bootstrap/scss/bootstrap-utilities.scss';

$circleSize: 270px;

.welcome-container {
  height: 100vh;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: map.get(themeVariables.$specificColors, sessionLayoutFieldBackground) !important;
  @media screen and (max-width: 920px) {
    grid-template-columns: 1fr;
  }
  // hide when smaller than 820px using media queries
}

.thumbnail-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 920px) {
    display: none;
  }
  //@include media-breakpoint-up(xl) {
  //  width: calc(100% - 400px);
  //}
}

.page-wrapper {
  position: relative;
  padding: 24px;
  box-sizing: border-box;
  background: white;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 1fr auto auto;
  grid-template-areas: '. . toggle' 'form form form' 'footer-actions copyright copyright';
  align-items: center;
  width: 100%;
  height: 100%;
  background: map.get(themeVariables.$colors, surface);
  //background: rgba(255, 255, 255, 0.6);

  //@include media-breakpoint-up(md) {
  //  top: auto;
  //  left: auto;
  //  padding: 1rem;
  //  justify-content: stretch;
  //  height: 100%;
  //  position: relative;
  //  background: $white;
  //  width: 100%;
  //  max-width: 100%;
  //}
  //
  //@include media-breakpoint-up(xl) {
  //  width: 400px;
  //}
}

.copyright {
  color: map.get(themeVariables.$colors, outline);
  grid-area: copyright;
}

.theme-toggle {
  grid-area: toggle;
  justify-self: end;
}

.left {
  display: flex;
  align-items: center;
}
.half-circle {
  border: 10px solid map.get(themeVariables.$colors, surface);
  border-radius: 100%;
  width: $circleSize;
  height: $circleSize;
  transform: translateX(calc($circleSize / 2));
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-dot,
.penalty-spot {
  width: 24px;
  height: 24px;
  background: map.get(themeVariables.$colors, surface);
  border-radius: 100%;
}

.penalty-area {
  width: 200px;
  height: 600px;
  border: 10px solid map.get(themeVariables.$colors, surface);
  border-left: none;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  justify-items: center;
}

.goal-area {
  width: 60px;
  height: 200px;
  border: 10px solid map.get(themeVariables.$colors, surface);
  border-left: none;
}

.penalty-arc-wrapper {
  width: 63px;
  overflow-x: hidden;
}

.penalty-arc {
  width: 244px;
  height: 244px;
  border: 10px solid map.get(themeVariables.$colors, surface);
  border-left: none;
  border-radius: 0 50% 50% 0;
  transform: translateX(calc(64px - 244px - 1px));
}
</style>
